import {Layout, Text} from '@di-nxt/components';
import React, {useCallback} from 'react';

type Props = {
  title: string;
  selected: boolean;
  index: number;
  onSelect?: (index: number) => void;
};

export const TabItem: React.FC<Props> = ({
  title,
  selected,
  index,
  onSelect,
}) => {
  const handleSelected = useCallback(() => onSelect && onSelect(index), [
    index,
    onSelect,
  ]);
  return (
    <Layout
      centered
      onPress={handleSelected}
      borderBottomColor={
        selected ? 'background_mono_inverse_primary' : 'transparent'
      }
      borderBottomStyle={'solid'}
      borderBottomWidth={'2'}>
      <Text variant={selected ? 'inline_14_emphasis' : 'inline_14_default'}>
        {title}
      </Text>
    </Layout>
  );
};
